import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins, faXmark, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash, faClock } from '@fortawesome/free-regular-svg-icons'
import StakeCard from "../components/StakeCard";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";

function Stake() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [stakeBar, setStakeBar] = useState(false);
  const toggleStakeBar = () => {
    setStakeBar(!stakeBar);
  };
  const [see, setSee] = useState(true);
  const [totalStake, setTotalStake] = useState(0);
  const [activestaking, setActivestaking] = useState([]);
  const [closedstaking, setClosedstaking] = useState([]);
  const [allstaking, setAllstaking] = useState([]);
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [stakes, setStakes] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchStakes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStakes(data.stakes);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStakes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const activeStakes = data.mystakes.filter(stake => stake.status === 1);
        const closedStakes = data.mystakes.filter(stake => stake.status === 0);
        const totalActiveAmount = activeStakes.reduce((sum, stake) => sum + parseFloat(stake.amount * stake.price), 0);
        setAllstaking(data.mystakes);
        setActivestaking(activeStakes);
        setClosedstaking(closedStakes);
        setTotalStake(totalActiveAmount);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Stake" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Stake" icon={<FontAwesomeIcon icon={faCoins} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mycard mt-2">
                  <div className="d-md-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center flex-wrap" style={{gap: '64px'}}>
                        <div>
                            <p className="text-secondary fw-bold mb-0">Total stakings <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} style={{fontSize: '13px', cursor: 'pointer'}} onClick={() => {
                            setSee(see === true ? false : true);
                            }}/></p>
                            <h2 className="fs-4 fw-bold mb-0">{(see === true)?getCurrencySymbol(user?.currency)+formatCurrency(totalStake * rate):'******'}</h2>
                        </div>
                        <div>
                            <p className="text-secondary fw-bold mb-0">Active stakings:</p>
                            <h2 className="fs-4 fw-bold mb-0">{activestaking.length}</h2>
                        </div>
                        <div>
                            <p className="text-secondary fw-bold mb-0">Closed stakings:</p>
                            <h2 className="fs-4 fw-bold mb-0">{closedstaking.length}</h2>
                        </div>
                    </div>
                    <div className="myBtn text-white" onClick={() => {toggleStakeBar()}} style={{fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgba(255, 255, 255, 0.05)'}}><FontAwesomeIcon icon={faClock} style={{fontSize: '14px'}} className="me-1"/> View stakings</div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <h5 className="mb-4 fw-bold text-white mt-5 ms-2">Pools</h5>
                <div className="row">
                {stakes.map((stake) => (
                    <div className="col-lg-4 col-6 col-12">
                     <StakeCard key={stake.id} coin_id={stake.coin_id} stake_id={stake.stake_id} image={<img src={stake.logo} alt={stake.name} width="100%" />} name={stake.name} symbol={stake.symbol} min={stake.minimum_amt} max={stake.maximum_amt} cycle={stake.cycle} roi={stake.roi} price={stake.price}/>
                    </div>
                                        ))}
                </div>
              </div>
            </div>
          </main>
        </div>
        <div className={`notifybar ${stakeBar ? "active" : null}`}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                    <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleStakeBar()}}/>
                    <p className="mb-0 fw-semibold ms-3 text-white">Staking History</p>
                </div>
                <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleStakeBar()}}/>
            </div>
            <div className="sidebar-navbar">
                {allstaking.length > 0 ? (
                  allstaking.map((staking, key) => (
                    <div className="table-responsive scrollDown" key={key}>
                      <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                        <thead>
                            <tr className="fs-7">
                              <th>ID</th>
                              <th>Ref</th>
                              <th>Amount</th>
                              <th>Duration</th>
                              <th className="text-nowrap">Total (USD)</th>
                              <th>ROI</th>
                              <th className="text-nowrap">Stake Date</th>
                              <th>Status</th>
                            </tr>
                        </thead>
                        <tbody style={{fontSize: '14px'}}>
                          <tr>
                              <td>{key + 1}</td>
                              <td>{staking.stake_id}</td>
                              <td>{formatCurrency(staking.amount)}</td>
                              <td>{staking.duration} {staking.duration == 1?'Day':'Days'}</td>
                              <td>{formatCurrency(staking.roi_usd)}</td>
                              <td className="text-nowrap">{staking.roi} {staking.symbol}</td>
                              <td className="text-nowrap">{staking.date}</td>
                              <td className={`${staking.status == 1?'text-success':'text-danger'}`}>{staking.status == 1?'Active':'Closed'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ))
                ) : (
                  <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100" style={{gap: '16px', color: 'rgba(255, 255, 255, 0.65)'}}>
                      <svg style={{width: '40px', height: '40px'}} className="svg-icon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.132 6.06h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.352 2.5h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V4.7c0-1.76.44-2.2 2.22-2.2Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.132 17.56h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.352 14h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V16.2c0-1.76.44-2.2 2.22-2.2ZM22.132 15.5c0 3.87-3.13 7-7 7l1.05-1.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.05 4.1 3.738 7.414M3.732 4.1l3.314 3.314" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
                      <p className=" mb-0 fw-semibold">No stakings yet.</p>
                  </div>
                )}
            </div>
        </div>
      </div>
    </div>
  )
}

export default Stake